import { useNavigate, useSearchParams } from "react-router-dom";
import LoginPages from "./LoginPages";
import { useEffect, useState } from "react";
import LoginService from "../../Service/API/LoginService";
import UserService from "../../Service/API/UserService";
import { addUserData, removeUserSession, setUserSession } from "../../Service/Variables/Common";
import { CatchLoginError } from "../../Service/Exceptions/exceptions";
import OtpPages from "./OtpPages";
import LoadingScreen from "../../Component/Loader/LoadingScreen";

function LoginMasterPages() {
    const [searchParams] = useSearchParams()
    const navigation = useNavigate()
    const loginService = new LoginService()
    const userService = new UserService()

    const id = searchParams.get('id')
    const [session, setSession] = useState({})
    const [customerId, setCustomerId] = useState(id)
    const [password, setPassword] = useState('')
    const [visible, setVisible] = useState(false)
    const isUseParams = !id
    const [mustRegister, setMustRegister] = useState(false)
    const [requireCustomerLogin, setrequireCustomerLogin] = useState(false)
    const [otpFilled, setOTPFilled] = useState(false)
    const [isLoad, setIsLoad] = useState(false)
    const [isUseTwoFA, setUseTwoFA] = useState(false)

    const [loginUsrIdentifier, setUsrIdentifier] = useState('')
    const [loginKey, setLoginKey] = useState('')
    const [otp, setOTP] = useState('')

    function forgotNav() {
        const params = customerId ? `?id=${customerId}` : ''
        navigation(`/forgot${params}`)
    }

  async function handleLogout () {
    try {
      console.log('Login Page Logouts')
      await userService.LogOut()
    } catch (error) {
      console.log(error.message)
    }
  }

  async function fetchAccountStatus () {
    try {
        if (!id) {
            return
        }

        const result = await loginService.checkAccounts(customerId)
        console.log(result.data)
        const { requireCustomerLogin: mustLogin, mustRegister: isRegister } = result.data

        setSession(result.data)
        setrequireCustomerLogin(mustLogin)
        setMustRegister(isRegister)

        if (isRegister === true) {
            navigation(`/register?id=${customerId}`)
        }

        if (!mustLogin) {
            console.log('trigger auto logins')
            const passwordOveride = 'no-pass-logins'
            setPassword(passwordOveride)
            await handleKeyRequest(passwordOveride)
        }
    } catch (error) {
      setIsLoad(false)
      return CatchLoginError(error, navigation)
    }
  }

  useEffect(() => {
    fetchAccountStatus()
    removeUserSession()
  }, [])

  // Handle first Layer of Authentication
  const handleKeyRequest = async(passwordOveride) => {
    try {
      setIsLoad(true)
      await handleLogout()
     // setLoading(true);
      const finalPass = passwordOveride
      const result = await loginService.requestToken(customerId, finalPass)
      const { useTwoFA, key, usrIdentifier } = result.data

      setUsrIdentifier(usrIdentifier)
      setLoginKey(key)
      if (!useTwoFA) {
        setIsLoad(false)
        await handleLogin(key, usrIdentifier)
        return true
      }
      setUseTwoFA(true)
      setIsLoad(false)
      return true
    } catch (error) {
      setIsLoad(false)
      return CatchLoginError(error, navigation)
    }
  }

   // handle button click of login form
  const handleLogin = async(key, usrIdentifier) => {
    try {
      setIsLoad(true)
      setOTPFilled(false)
     // setLoading(true);
      const dat = await loginService.login(loginUsrIdentifier || usrIdentifier, loginKey || key, otp)

      const user = dat.user
      const data = dat.data

      addUserData(user)
      setUserSession(data.accesstoken, data.refreshtoken, user)
    //   await fetch()
      setIsLoad(false)
     // setLoading(false);
      navigation('/home')
    } catch (error) {
        console.log(error.message)
      setOTPFilled(false)
      setIsLoad(false)
      return CatchLoginError(error, navigation)
    }
  }

  // const handlerMakeAccount = () => {
  //   navigation('/login/register-page')
  // }

  useEffect(() => {
    document.body.classList.add("login");
    return function cleanup() {
      document.body.classList.remove("login");
    };
  }, []);


    const state = {
                customerId,
                setCustomerId,
                isUseParams,
                password,
                setPassword,
                handleKeyRequest,
                handleLogin,
                visible,
                setVisible,
                forgotNav,
                setOTP,
                otpFilled,
                isLoad,
                userService,
                navigation,
                session,
                requireCustomerLogin,
                mustRegister
            }

    const loginPanels = (
        <>
        {!isUseTwoFA ? (
            <LoginPages
                state = {state}
            />)
        : (
            <>
                <OtpPages
                    state = {state}
                />
            </>
        )
        }
        </>
    );

    return (<>
        <LoadingScreen
            loading={isLoad}
            children={loginPanels}
        />
    </>)
}

export default LoginMasterPages;
